import { VersionsGetRequestParams } from "@lib/core";

export interface VersionDefaultParams extends VersionsGetRequestParams { }
export class VersionDefaultParams {
  constructor() {
    this.select = "*,\
      algorithm:algorithms(*),\
      latest_firmware:firmware!fk_latest_firmware_id(*)";
    this.order = "id.asc";
  }
}